import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { SnackbarTypes } from 'src/app/core/_enums/snackbar.types';
import { User } from 'src/app/core/_models/user';
import { AccountService } from 'src/app/core/_services/account.service';
import { SnackbarService } from 'src/app/core/_services/snackbar.service';
import { SpinnerOverlayService } from 'src/app/core/_services/spinner.overlay.service';
import CheckPassValidation from 'src/app/core/_utils/validation';
import { GlobalConstants } from 'src/constants/global.constants';
import { UserAccountConstants } from 'src/constants/useraccount.constants';

@Component({
  selector: 'app-account',
  templateUrl: './account.component.html',
  styleUrls: ['./account.component.scss']
})
export class AccountComponent implements OnInit {
  form!: FormGroup;
  isChangePassword: boolean = false;

  CONSTANTS = GlobalConstants;

  constructor(
    private formBuilder: FormBuilder,
    private accountService: AccountService,
    private snackbarService: SnackbarService,
    private spinnerService: SpinnerOverlayService,
    public USER_ACCOUNT_CONSTANTS: UserAccountConstants
  ) {
    this.form = this.formBuilder?.group(
      {
        userId: [],
        userName: [null, Validators.required],
        userLogin: [{ value: null, disabled: true }],
        userFirstName: [null, Validators.required],
        email: [null, [Validators.required, Validators.email]],
        status: [{ value: null, disabled: true }],
        oldPassword: [''],
        password: [''],
        confirmPassword: ['']
      },
      {
        validators: [CheckPassValidation.match('password', 'confirmPassword')]
      }
    );
  }

  ngOnInit(): void {
    this.spinnerService.show();
    this.accountService.getUser().subscribe(
      (user) => {
        if (user) this.form.patchValue(user);

        setTimeout(() => {
          this.spinnerService.hide();
        }, 500);
      },
      (error) => {
        this.snackbarService.open(SnackbarTypes.error);
        this.spinnerService.hide();
      },
      () => {
        this.spinnerService.hide();
      }
    );
  }

  get formCrls() {
    return this.form?.controls;
  }

  clickSave() {
    if (this.form.invalid) {
      return;
    }

    const userForm = Object.assign({}, this.form.getRawValue()) as User;

    this.accountService.updateUser(userForm).subscribe((rep) => {
      this.snackbarService.open(SnackbarTypes.add);
      this.form.patchValue(rep);
    });
  }

  addValidators(frm: any, isChangePassword: boolean) {
    this.isChangePassword = !isChangePassword;
    if (this.isChangePassword) {
      frm.oldPassword.setValidators([Validators.required]);
      frm.password.setValidators([Validators.required, Validators.minLength(8), Validators.pattern(this.USER_ACCOUNT_CONSTANTS.PasswordPattern)]);
      frm.confirmPassword.setValidators([Validators.required, Validators.minLength(8), Validators.pattern(this.USER_ACCOUNT_CONSTANTS.PasswordPattern)]);
    } else {
      frm.oldPassword.clearValidators();
      frm.password.clearValidators();
      frm.confirmPassword.clearValidators();
    }
    frm.oldPassword.updateValueAndValidity();
    frm.password.updateValueAndValidity();
    frm.confirmPassword.updateValueAndValidity();
  }
}
